"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import { Search, Heart, Flame } from "lucide-react";
import { cn } from "@/lib/utils";
import { isNavActive } from "./nav-links";

const TABS = [
  { href: "/", label: "Browse", icon: Search },
  { href: "/favorites", label: "Favorites", icon: Heart },
  { href: "/popular", label: "Popular", icon: Flame },
] as const;

/**
 * Bottom navigation for small viewports. Hidden on large screens where the
 * header carries the same links; hidden inside admin, which has its own nav.
 */
export function MobileTabBar() {
  const pathname = usePathname();
  if (pathname.startsWith("/admin")) return null;

  return (
    <nav
      aria-label="Primary"
      className="fixed inset-x-0 bottom-0 z-40 border-t border-line bg-[rgb(8_7_15/0.82)] pb-safe backdrop-blur-xl lg:hidden"
    >
      <ul className="mx-auto grid h-[4.25rem] max-w-md grid-cols-3">
        {TABS.map((tab) => {
          const active = isNavActive(pathname, tab.href);
          const Icon = tab.icon;
          return (
            <li key={tab.href} className="flex">
              <Link
                href={tab.href}
                aria-current={active ? "page" : undefined}
                className={cn(
                  "flex flex-1 flex-col items-center justify-center gap-1 text-[11px] font-medium transition-colors",
                  "focus-visible:outline-2 focus-visible:-outline-offset-2 focus-visible:outline-accent",
                  active ? "text-accent" : "text-ink-3"
                )}
              >
                <span
                  className={cn(
                    "flex h-7 w-12 items-center justify-center rounded-full transition-colors",
                    active && "bg-accent-tint"
                  )}
                >
                  <Icon className="size-[18px]" strokeWidth={active ? 2.2 : 1.8} />
                </span>
                {tab.label}
              </Link>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
